import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-bootstrap/Spinner";

const Loading = ({ fullHeight = false }) => (
  <div className={fullHeight ? "loading-overlay" : "table-loading-area"}>
    <Spinner animation="border" size="lg" variant="secondary" />
  </div>
);

Loading.propTypes = {
  fullHeight: PropTypes.bool,
};

export default Loading;
